import type { ReactNode } from 'react'
import { Symbol } from './Symbol'

/**
 * Eine Pille zum Antippen.
 *
 * Mit `gewaehlt` ist sie ein FILTER: sie hat einen Zustand, meldet ihn als
 * `aria-pressed` und zeigt ihn zusätzlich als Haken. Farbe allein genügt
 * nicht: bei den häufigen Farbfehlsichtigkeiten sieht eine getönte Pille aus
 * wie eine ungetönte.
 *
 * ⚠️ OHNE `gewaehlt` ist sie ein VORSCHLAG und trägt bewusst kein
 * `aria-pressed`. Ein Vorschlag führt etwas aus und bleibt nicht gedrückt
 * zurück; ihn als Schalter anzusagen wäre eine Falschaussage gegenüber jeder
 * Sprachausgabe.
 */
export function Chip({
  gewaehlt,
  onClick,
  children,
}: {
  gewaehlt?: boolean | undefined
  onClick?: () => void
  children: ReactNode
}) {
  return (
    <button
      type="button"
      className={`chip${gewaehlt ? ' chip--an' : ''}`}
      {...(gewaehlt === undefined ? {} : { 'aria-pressed': gewaehlt })}
      onClick={onClick}
    >
      <span className="chip__inhalt">
        {gewaehlt ? <Symbol name="check" className="chip__haken" /> : null}
        <span className="chip__label">{children}</span>
      </span>
    </button>
  )
}
